import { render, staticRenderFns } from "./TransportModeBlockPass.vue?vue&type=template&id=5948b4f6"
import script from "./TransportModeBlockPass.vue?vue&type=script&lang=ts"
export * from "./TransportModeBlockPass.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports